<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="onCreate()"
                    matTooltip="{{ 'add_user_tooltip' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <ng-container *transloco="let t">
                            <pixl-free-filter-input
                                [label]="t('email-address')"
                                [matIcon]="'search'"
                                [hint]="getSearchFilterHint()"
                                [minLength]="freeFilterLen"
                                (onKeyUpChange)="setNameFilter($event)"
                            />
                        </ng-container>
                    </div>
                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>{{ "role" | transloco }}</mat-label>
                            <mat-select (valueChange)="setRoleFilter($event)">
                                <mat-option [value]="''">---</mat-option>
                                <mat-option [value]="'author'">{{ "author" | transloco }}</mat-option>
                                <mat-option [value]="'editor'">{{ "editor" | transloco }}</mat-option>
                                <mat-option [value]="'appAdmin'">{{ "appAdmin" | transloco }}</mat-option>
                                <mat-option [value]="'zavAdmin'">{{ "zavAdmin" | transloco }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="main-toolbar-spacer-right"></div>
        </div>
        <div class="table-header-overlay"></div>
    </div>

    <div class="table-container mat-elevation-z4">
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="edit-actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let editor"
                    class="action-column no-wrap"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="primary"
                        aria-label="Edit"
                        (click)="openEditDialog(editor)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    @if (this.authState().editor?.email !== editor.email) {
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="warn"
                        aria-label="Delete"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                        (click)="confirmDelete(editor)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let editor"
                >{{ editor.id }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "email-address" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let editor"
                >{{ editor.email }}</td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "role" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let editor"
                    class="no-wrap"
                >
                    {{ getEditorRole(editor.role) }}
                </td>
            </ng-container>

            <!--
      <ng-container matColumnDef="subjects">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fächer</th>
        <td mat-cell *matCellDef="let editor">{{ editor.subjects }}</td>
      </ng-container>
      -->

            <ng-container matColumnDef="updated">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "updated" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let editor"
                >
                    {{ isValidDate(editor.updated) ? (editor.updated | date) : "---" }}
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>

        <!--<mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 1000]" [pageSize]="pageSize" [length]="totalItems()"
      (page)="handlePageEvent($event)" showFirstLastButtons></mat-paginator>-->
        <pixl-main-pagination [pageChangeCallback]="paginationChanged"></pixl-main-pagination>
    </div>
</div>